import { Card } from '@pmi/dsm-react';
import { AdminActions, AdministratorUserApiModel } from '../models';
import RegisteredCell from '../AdminsList/TableCells/RegisteredCell';
import ActionsCell from '../AdminsList/TableCells/ActionsCell';
import RoleCell from '../AdminsList/TableCells/RoleCell';
import { PeopleCardListItemProperty } from '../../PeopleCardList';
import styles from './adminCardListTemplate.module.scss';
import LastLoggedIn from '../AdminsList/TableCells/LastLoggedIn';

interface AdminCardListTemplateProps<T, A>
  extends PeopleCardListItemProperty<T, A> {
  personId: number;
}
export default function AdminCardListTemplate({
  item,
  actions,
  personId = 0,
}: AdminCardListTemplateProps<AdministratorUserApiModel, AdminActions>) {
  const { name, email, invitationEmail, phoneNumber } = item;
  return (
    <Card className="listItemCard mb-3">
      <div className="p-0">
        <div className="p-4 pb-3">
          <div className="d-block mb-1" data-exclude-lg>
            <strong className={styles.name}>{name}</strong>
            <span className={styles.email}>{email ?? invitationEmail}</span>
            <span className={styles.phoneNumber}>{phoneNumber}</span>
          </div>
          <div className="d-block mb-3">
            <span
              className={`${styles.textContent} d-flex align-items-center gap-1 small`}
            >
              <span>PMI ID:</span>
              <span>{item.personId || 'N/A'}</span>
            </span>
          </div>
          <div className="d-block">
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Role: </span>
              <RoleCell row={{ original: item }} />
            </div>
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Registration: </span>
              <RegisteredCell row={{ original: item }} />
            </div>
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Last Accessed: </span>
              <LastLoggedIn row={{ original: item }} />
            </div>
          </div>
        </div>
        <div className={styles.actionBtns}>
          <ActionsCell
            row={{ original: item }}
            actions={actions}
            personId={personId}
          />
        </div>
      </div>
    </Card>
  );
}
